import { css, styled } from 'next-yak';

import { xdlColorError, xdlColorTextSecondary } from '@xing-com/tokens';
import { Meta } from '@xing-com/typography';

const CharacterCounter = styled(Meta)<{
  $maxCountReached: boolean;
}>`
  ${({ $maxCountReached }) =>
    $maxCountReached
      ? css`
          /* Meta's styled-components color rule uses a doubled selector. */
          &&& {
            color: ${xdlColorError};
          }
        `
      : css`
          color: ${xdlColorTextSecondary};
        `};
`;

export const Styled = {
  CharacterCounter,
};
